import React from "react";
import { FormattedMessage } from "react-intl";

import PageContent from "2g-page-content";
import PageMessage from "2g-page-message";

function NotFound() {
  return (
    <PageContent>
      <PageMessage>
        <FormattedMessage id="b2b.components.not-found" />
      </PageMessage>
      ;
    </PageContent>
  );
}

export default React.memo(NotFound);
